// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "26ed9e264606765175de6191242489f372ba8600/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};